// prettier-ignore
export const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
export const websiteDomain = process.env.REACT_APP_WEB_DOMAIN;
export const URMART_VIP_SKU = "URMARTVIP-BESTPRICE";

/** 版本參數 */
export const appVersion = process.env.APP_VERSION; // package.json version
